// extracted by mini-css-extract-plugin
module.exports = {"cell":"LKTable_cell__39Cd4"};